module.exports = __webpack_public_path__ + "static/14-471419d2a78dbfde7cb5c6145dd72ba6.jpg";